function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { createContext, useContext, useReducer, useCallback, useEffect, useState } from 'react';
import { accordionReducer, initialState } from './accordionReducer';
export var AccordionContext = /*#__PURE__*/createContext({
  addItem: _ref => {
    var {
      value = '',
      isOpen = false
    } = _ref;
    return;
  },
  toggleItem: _ref2 => {
    var {
      value = ''
    } = _ref2;
    return;
  },
  toggleSingleItem: _ref3 => {
    var {
      value = ''
    } = _ref3;
    return;
  },
  addChild: _ref4 => {
    var {
      value = '',
      childValue = ''
    } = _ref4;
    return;
  },
  type: '',
  state: {
    items: []
  },
  collapsible: false,
  startOpen: false,
  variant: '',
  defaultValue: ''
});
export var AccordionProvider = _ref5 => {
  var {
    children,
    value: {
      collapsible = false,
      type = '',
      variant = '',
      defaultValue = '',
      onValueChange,
      startOpen = false,
      value: controlledValue
    } = {}
  } = _ref5;
  var [state, dispatch] = useReducer(accordionReducer, initialState);
  var [currentOpenedItems, setCurrentOpenedItems] = useState([]);
  var previousValue = React.useRef('');
  var [isToggling, setIsToggling] = useState(false);
  var timingOfadd = React.useRef(null);
  var itemSize = React.useRef(0);
  var lastDefaultToOpen = React.useRef(null);
  useEffect(() => {
    if (controlledValue && controlledValue !== previousValue.current && type === 'single') {
      toggleSingleItem({
        value: controlledValue
      });
      previousValue.current = controlledValue;
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [controlledValue]);
  useEffect(() => {
    itemSize.current = state.items.length;
  }, [state.items]);
  useEffect(() => {
    if (defaultValue && defaultValue !== lastDefaultToOpen.current) {
      clearTimeout(timingOfadd.current);
      timingOfadd.current = setTimeout(() => {
        var currentItem = state.items.find(item => item.value === defaultValue);

        if (currentItem && !currentItem.isOpen) {
          var {
            value,
            level = 0
          } = currentItem;

          if (type === 'multiple' || level > 1) {
            openSelected({
              value
            });
          }
          /* istanbul ignore else */


          if (type === 'single' && level === 1) {
            toggleSingleItem({
              value
            });
          }

          lastDefaultToOpen.current = defaultValue;
        }
      }, 100);
    }
  }, [defaultValue, state.items]);
  useEffect(() => {
    if (isToggling) {
      if (typeof onValueChange === 'function') {
        var _openedItems = state.items.filter(item => item.isOpen).map(item => item.value);

        var isDifferent = JSON.stringify(_openedItems) !== JSON.stringify(currentOpenedItems);
        /* istanbul ignore else */

        if (isDifferent) {
          onValueChange(type === 'single' ? _openedItems[0] : _openedItems);
          setCurrentOpenedItems(_openedItems);
        }
      }
    }

    setIsToggling(false); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.items, isToggling]);
  var addItem = useCallback(_ref6 => {
    var {
      value = '',
      isOpen = false,
      triggerId = '',
      labelledId = '',
      level = 1,
      ref = null,
      childrenValue = [],
      parentValue = '',
      disabled = false
    } = _ref6;
    dispatch({
      type: 'ADD_ITEM',
      payload: {
        value,
        isOpen: startOpen ? true : isOpen,
        triggerId,
        labelledId,
        ref,
        level,
        childrenValue,
        parentValue,
        disabled
      }
    });
  }, []);

  var toggleItem = _ref7 => {
    var {
      value = '',
      level = 1
    } = _ref7;
    dispatch({
      type: 'TOGGLE_ITEM',
      payload: {
        value,
        level
      }
    });
    setIsToggling(true);
  };

  var toggleSingleItem = _ref8 => {
    var {
      value = '',
      level = 1
    } = _ref8;
    dispatch({
      type: 'TOGGLE_SINGLE_ITEM',
      payload: {
        value,
        collapsible,
        level
      }
    });
    setIsToggling(true);
  };

  var openSelected = _ref9 => {
    var {
      value = ''
    } = _ref9;
    dispatch({
      type: 'OPEN_SELECTED',
      payload: {
        value
      }
    });
  };

  var addChild = useCallback(_ref10 => {
    var {
      value = '',
      childValue = ''
    } = _ref10;
    dispatch({
      type: 'ADD_CHILDREN',
      payload: {
        value,
        childValue
      }
    });
  }, []);
  return /*#__PURE__*/React.createElement(AccordionContext.Provider, {
    value: {
      addItem,
      toggleItem,
      toggleSingleItem,
      addChild,
      state,
      type,
      collapsible,
      variant,
      defaultValue,
      startOpen
    }
  }, children);
};
export var useAccordion = () => useContext(AccordionContext);
export default _extends({}, AccordionContext, {
  Provider: AccordionProvider
});
//# sourceMappingURL=AccordionContext.js.map